import { render } from "./PlansPage.vue?vue&type=template&id=03c3e3f1&scoped=true&ts=true"
import script from "./PlansPage.vue?vue&type=script&lang=ts"
export * from "./PlansPage.vue?vue&type=script&lang=ts"

import "./PlansPage.vue?vue&type=style&index=0&id=03c3e3f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c3e3f1"]])

export default __exports__